import { render, staticRenderFns } from "./RegisterPass.vue?vue&type=template&id=5ffc163f&scoped=true&"
import script from "./RegisterPass.vue?vue&type=script&lang=js&"
export * from "./RegisterPass.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPass.vue?vue&type=style&index=0&id=5ffc163f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc163f",
  null
  
)

export default component.exports